import qs from 'query-string';

export const redirectPageIfNeeded = () => {
  if (typeof window !== 'undefined') {
    const fullUrl = window.location.href;
    const { url, query: { redirectPage, ...rest } } = qs.parseUrl(fullUrl);

    if (redirectPage === 'passport-upload') {
      const paramsString = qs.stringify({ ...rest });
      const redirectUrl = `${url}#/settings/passport-upload/?${paramsString}`;
      window.location.href = redirectUrl;
    }
  }

  return undefined;
};
